import { Injectable } from '@angular/core';
import { ContentEventApi } from '@kapi';
import { ContentEventCreatedResponse, ContentEventType } from '@ktypes/enums';
import { ContentEvent, JsonObject } from '@ktypes/models';
import { DateTimeUtil } from '@kutil';
import { BehaviorSubject, Observable, scan, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContentEventBloc {
  constructor(private _contentEventApi: ContentEventApi) {}

  private _contentEventResponse$ = new BehaviorSubject<ContentEventCreatedResponse>(null);

  get latestContentEventResponse$(): Observable<ContentEventCreatedResponse> {
    return this._contentEventResponse$.asObservable();
  }

  get contentEventResponses$(): Observable<void | ContentEventCreatedResponse[]> {
    return this._contentEventResponse$.pipe(
      scan((responses: ContentEventCreatedResponse[], contentEventResponse: ContentEventCreatedResponse) => {
        responses.push(contentEventResponse);
        return responses;
      }, []),
      shareReplay(1)
    );
  }

  createContentEvent(contentId: string, eventType: ContentEventType, eventInfo?: JsonObject) {
    this._contentEventApi
      .createContentEvent(
        new ContentEvent().deserialize({
          contentId,
          deviceCreatedTimestamp: DateTimeUtil.formatInLocal(),
          eventInfo,
          eventType,
        })
      )
      .then((response) => {
        this._contentEventResponse$.next({ ...response, eventInfo });
      });
  }
}
